var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form-element',_vm._b({},'v-form-element',_vm.safeProps,false),[_c('vc-date-picker',{ref:"input",attrs:{"id":_vm.id,"locale":_vm.$store.state.locale,"input-props":{
            class: _vm.className,
            placeholder: _vm.getPlaceholder(),
            readonly: _vm.disabled
        },"masks":_vm.masks,"min-date":_vm.minDate,"max-date":_vm.maxDate,"popover":_vm.popover},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }